import {
  CheckoutFormValues,
  SelectedAppointment,
} from '../../types/appointments';
import { isGuestCheckout as checkIsGuestCheckout } from '../../helpers/payments';
import useGetGiftCardItem from '../giftCards/useGetGiftCardItem';

/** Gift cards need a live gift card item and a customer to issue them to. */
export default function useGiftCardsEnabled({
  customer,
  appointment,
  enabled = true,
}: {
  customer: CheckoutFormValues['customer'];
  appointment: SelectedAppointment | null;
  enabled?: boolean;
}) {
  const { data: giftCardItem } = useGetGiftCardItem({ enabled });
  const isGuestCheckout = checkIsGuestCheckout({ customer, appointment });

  return !!giftCardItem && !giftCardItem.deletedAt && !isGuestCheckout;
}
